<template>
    <div class="payment-history">
        <div class="payment-iocn payment-approved">
            <img src="@/assets/images/payment-approved.svg" alt="payment-approved" loading="lazy">
        </div>
        <div class="request_title">
            <h3>{{ walletDetails?.user_name }}</h3>
            <p>{{ walletDetails?.type==2 ? $t('deposit', 'Deposit') : $t('withdraw', 'Withdraw')}} {{$t('request-approved', 'Request Approved')}}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "DepositRequestApproved",
    props:['walletDetails'],
}
</script>